import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { highlightMatchedText } from '@atlassian/search-common';
import { RECENT_SEARCHES_SECTION_ID } from '../../../quick-find/quick-find-confluence/sections/recent-search-section';
import uniqBy from 'lodash/uniqBy';
export var filterFirstSectionItems = function filterFirstSectionItems(searchItems, query) {
  var numberOfResultItems = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;
  if (!searchItems.sections[0]) {
    return searchItems;
  }
  var filteredSearchResults = searchItems.sections[0].searchResults.filter(function (item) {
    return item.title.toLowerCase().includes(query.toLowerCase());
  }).slice(0, numberOfResultItems);
  return {
    size: filteredSearchResults.length,
    sections: [_objectSpread(_objectSpread({}, searchItems.sections[0]), {}, {
      searchResults: filteredSearchResults
    })]
  };
};
export var filterAllSectionItems = function filterAllSectionItems(searchItems, query) {
  var numberOfResultItems = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;
  if (query === '') {
    return searchItems;
  }
  var wordsInQuery = query.split(' ');
  var itemScoreMap = {};
  var filteredSearchSections = searchItems.sections.map(function (section) {
    return _objectSpread(_objectSpread({}, section), {}, {
      searchResults: section.searchResults.map(function (item) {
        // 1st pass
        var doAllWordsMatch = wordsInQuery.reduce(function (acc, word) {
          if (!acc) {
            return acc;
          }
          return item.title.toLowerCase().includes(word.toLowerCase());
        }, true);
        if (doAllWordsMatch) {
          // 2nd and 3rd Pass
          var _highlightMatchedText = highlightMatchedText(item.title, wordsInQuery),
            highlightedTitle = _highlightMatchedText.highlightedTitle,
            negatedHighlightedTitle = _highlightMatchedText.negatedHighlightedTitle,
            _highlightMatchedText2 = _highlightMatchedText.score,
            score = _highlightMatchedText2 === void 0 ? 0 : _highlightMatchedText2;
          itemScoreMap[item.id] = score;
          return _objectSpread(_objectSpread({}, item), {}, {
            highlightedTitle: section.id !== RECENT_SEARCHES_SECTION_ID ? highlightedTitle : negatedHighlightedTitle
          });
        }
        return null;
      }).filter(function (item) {
        return item;
      }).sort(function (item, secondItem) {
        return item && secondItem ? itemScoreMap[secondItem.id] - itemScoreMap[item.id] : 0;
      }).slice(0, numberOfResultItems)
    });
  });
  var size = filteredSearchSections.map(function (section) {
    return section.searchResults.length;
  }).reduce(function (acc, b) {
    return acc + b;
  }, 0);
  return {
    size: size,
    sections: filteredSearchSections
  };
};
export var highlightPostQueryResultTitles = function highlightPostQueryResultTitles(postQueryItems, query) {
  var wordsInQuery = query.split(' ');
  var highlightedSearchSections = postQueryItems.sections.map(function (section) {
    return _objectSpread(_objectSpread({}, section), {}, {
      searchResults: section.searchResults.map(function (item) {
        var _highlightMatchedText3 = highlightMatchedText(item.title, wordsInQuery),
          highlightedTitle = _highlightMatchedText3.highlightedTitle;
        return _objectSpread(_objectSpread({}, item), {}, {
          highlightedTitle: highlightedTitle
        });
      })
    });
  });
  return {
    size: postQueryItems.size,
    sections: highlightedSearchSections
  };
};
export var mergeFirstSectionSearchItems = function mergeFirstSectionSearchItems(intermediateSearchItems, postQuerySearchItems) {
  var _intermediateSearchIt, _postQuerySearchItems;
  if (!intermediateSearchItems.sections[0] || ((_intermediateSearchIt = intermediateSearchItems.sections[0]) === null || _intermediateSearchIt === void 0 ? void 0 : _intermediateSearchIt.searchResults.length) === 0) {
    return postQuerySearchItems;
  }
  if (!postQuerySearchItems.sections[0] || ((_postQuerySearchItems = postQuerySearchItems.sections[0]) === null || _postQuerySearchItems === void 0 ? void 0 : _postQuerySearchItems.searchResults.length) === 0) {
    return intermediateSearchItems;
  }
  var fullMergedResultsList = [].concat(_toConsumableArray(intermediateSearchItems.sections[0].searchResults.map(function (result) {
    return _objectSpread(_objectSpread({}, result), {}, {
      isRecentResult: true
    });
  })), _toConsumableArray(postQuerySearchItems.sections[0].searchResults));
  var deduplicatedList = uniqBy(fullMergedResultsList, function (item) {
    return item.id;
  });
  var sections = [_objectSpread(_objectSpread({}, postQuerySearchItems.sections[0]), {}, {
    searchResults: deduplicatedList
  })];
  return {
    size: sections.reduce(function (accumulator, currentElem) {
      return accumulator + currentElem.searchResults.length;
    }, 0),
    sections: sections
  };
};